import base from "../../../base.js";


export default class FilterBase extends base {
    objectType = "FilterBaseItem";
    Enabled = true;
    Tooltip = "";

    constructor(args = {}) {
        super(args);
    }

    objectToClassValue(args = {}) {
        super.objectToClassValue(args);
        this.Enabled = args.enabled || true;
        this.Tooltip = args.tooltip || "";
        this.CanBeHide = false;
        this.CanChangeName = false;
    }

    async filterAction(cv, cvImage) {
        return cvImage;
    }

    static get Name() {
        return "FilterBase";
    }

    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "Enabled", construct: Boolean, jsType: "Boolean" },
        ];
    }

    get planSize() {
        let size = null;
        let parent = this.parent;
        while (parent) {
            if (parent.Position) {
                return parent.Position;
                break;
            }
            parent = parent.parent;
        }
        return { width: 1000, height: 1000 };
    }

    invalidateFilterCache() {
        if (this.parent && this.parent.invalidateFilterCache)
            this.parent.invalidateFilterCache();
    }

    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            enable: this.Enabled,
        };
    }

    toObject(minify = false) {
        return {
            ...super.toObject(minify),
            enabled: this.Enabled,
        };
    }
}